import {
  DotsHostAgentManagementClient,
  EchoCommand,
  EchoCommandInput,
  EchoCommandOutput,
  GetHostCommand,
  GetHostCommandInput,
  GetHostCommandOutput,
} from '@amzn/dots-host-agent-management-service-client';
import { AuthContext } from '@amzn/dots-core-ui';
import { environment } from '$/environments';

// TODO: make endpoint configurable for alpha/beta/gamma/prod
export async function getHamsClient(auth: AuthContext) {
  const token = await auth.createToken();

  return new DotsHostAgentManagementClient({
    endpoint: environment.hostAgentServiceApiUrl,
    region: 'us-west-2',
    apiKey: { apiKey: `Bearer ${token}` },
  });
}

// example call to dummy echo endpoint
export async function echo(
  input: EchoCommandInput,
  client: DotsHostAgentManagementClient
): Promise<EchoCommandOutput> {
  return client.send(new EchoCommand(input));
}

export async function getHost(
  input: GetHostCommandInput,
  client: DotsHostAgentManagementClient
): Promise<GetHostCommandOutput> {
  return client.send(new GetHostCommand(input));
}
